import type { Field } from '@/components/PersonInPlaceEditor/types';
import { InsurancePolicy as InsurancePolicyInterface } from '@/types/insurancePolicy';

const SELF_PAY_FIELD_KEYS: string[] = ['id', 'is_mutable', 'plan_start_date', 'plan_end_date'];

export const getSelfPayInsuranceFields = (
  fields: Field<InsurancePolicyInterface>[]
): Field<InsurancePolicyInterface>[] =>
  fields.filter(({ key }) => SELF_PAY_FIELD_KEYS.includes(key));
